var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex content-center rounded-full bg-gray-100 w-24 h-24 p-4"},[_c('img',{staticClass:"block w-full h-full",attrs:{"src":_vm.picture ? _vm.picture : _vm.picture_default,"alt":"user image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }